import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const GlobalConsentBanner = () => {
    const { t, i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const isArabic = i18n.language?.startsWith('ar');

    useEffect(() => {
        const consent = localStorage.getItem('global_consent_v1');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('global_consent_v1', JSON.stringify({
            analytics: true,
            marketing: true,
            essential: true,
            timestamp: new Date().toISOString()
        }));
        setIsVisible(false);
    };

    const handleEssentialOnly = () => {
        localStorage.setItem('global_consent_v1', JSON.stringify({
            analytics: false,
            marketing: false,
            essential: true,
            timestamp: new Date().toISOString()
        }));
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            className="fixed bottom-6 left-6 right-6 z-[9999] flex flex-col md:flex-row items-center justify-between p-6 gap-6 shadow-2xl animate-slide-up"
            style={{
                backgroundColor: 'var(--bg-header)',
                borderRadius: 'var(--card-radius)',
                border: '1px solid var(--border)',
                backdropFilter: 'blur(10px)'
            }}
        >
            <div className={`flex-1 ${isArabic ? 'text-right' : 'text-left'}`}>
                <h3 className="text-lg font-black mb-2" style={{ color: 'var(--text-header)' }}>
                    {t('compliance.consent_title', 'Your Privacy Matters')}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed max-w-2xl">
                    {t('compliance.consent_desc', 'We use cookies and process personal data to enhance your experience, analyze traffic, and for marketing purposes in compliance with GDPR, PDPL (KSA/UAE), and Egyptian Law 151/2020.')}
                    {' '}
                    <Link to="/privacy" className="text-brand-primary underline font-bold">
                        {t('footer.privacy_policy', 'Privacy Policy')}
                    </Link>
                </p>
            </div>

            <div className="flex flex-wrap gap-3 w-full md:w-auto">
                <button
                    onClick={handleEssentialOnly}
                    className="flex-1 md:flex-none px-6 py-3 text-sm font-bold rounded-xl border transition-all active:scale-[0.98]"
                    style={{ borderColor: 'var(--border)', color: 'var(--text-header)' }}
                >
                    {t('compliance.essential_only', 'Essential Only')}
                </button>
                <button
                    onClick={handleAcceptAll}
                    className="flex-1 md:flex-none px-8 py-3 text-sm font-black rounded-xl bg-gray-900 text-white hover:bg-brand-primary transition-all shadow-lg shadow-brand-primary/20 active:scale-[0.98]"
                >
                    {t('compliance.accept_all', 'Accept All')}
                </button>
            </div>
        </div>
    );
};

export default GlobalConsentBanner;
